"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shoppingPortalActions = void 0;
const init_1 = __importDefault(require("./init"));
exports.shoppingPortalActions = {
    init: init_1.default
};
